'use strict';
const priceSubscriberMixin = require('../../modules/mixins/price_subscriber.mixin');
const tripTypeUtils = require('../../modules/utils/trip_type');
const insuranceCatalogueCollection = require('../../modules/collections/insurance_catalogue.collection');
const FLIGHT_SUMMARY_PAGE = 'flightsummary';
const MOBILEFLOW = 'mobile';

module.exports = Odigeo.Model.extend(priceSubscriberMixin.extend({
    connect: true,
    selectors: ['includedBags'],
    dataUrl: 'getcollapsibleflightsummarydata',
    metaUrl: 'meta/flightdetails',
    showFreeRefundableFlexDis: false,
    defaults: {
        isDeparture: true,
        segmentNumber: 0,
    },

    getData() {
        this.options = Odigeo.parseOptions(this.widget.options);
        this.fetch(this.getDataRequestSettings());
    },
    url() {
        const url = this.shouldUseMetaEndpoint() ? this.metaUrl : this.dataUrl;
        return Odigeo.Settings.getProperty('serviceUrlFormatter')(url);
    },
    getDataRequestSettings() {
        return {
            type: 'GET',
            processData: true,
        };
    },
    parse(response) {
        let parsedResponse = response;
        if (!response && !Odigeo.AB.isPreCreateShoppingCartInDetails) {
            Odigeo.UIElements.showSearchExpiredError();
        } else if (response && !response.flightDetailsDTO) {
            const searchParameters = Odigeo.Session.get('searchParameters');
            const tripType = searchParameters ? Odigeo.Utils.parseJson(searchParameters).type : '';

            response.segments = this.processResponseForResults(response);
            parsedResponse = {
                flightDetailsDTO: response,
                tripType,
            };
        }

        if (parsedResponse && !this.options.isResults && Odigeo.History.getPageNameFromFragment() !== FLIGHT_SUMMARY_PAGE) {
            parsedResponse.tripType = tripTypeUtils.fromResults(parsedResponse.tripType);
        }

        return parsedResponse;
    },
    processResponseForResults(response) {
        return Odigeo._.map(response.itineraryGroupsList, function(segment) {
            segment = Odigeo._.merge({}, segment, segment.segments[0]);
            delete segment.segments;
            return segment;
        });
    },

    setData(data, {silent} = {}) {
        this.set('bookingData', data, {silent});
        this.dataUrl = `result/flightdetailsfiltered`;
        this.getFlightDetailsData({silent});
        if (!silent) {
            this.renderFlexAlert();
        }
    },

    getFlightDetailsData({silent} = {}) {
        const {itineraryID, segmentPositions} = this.getBookingData();
        const leg = segmentPositions[0].leg;
        const flightDetailsDataRequest = {
            fareId: itineraryID,
            flightDetailsSegmentRequestList: segmentPositions.map((sp) => {
                return {
                    itineraryGroupId: sp.leg,
                    segmentId: sp.segment,
                };
            }),
        };

        this.fetch({
            type: 'POST',
            url: Odigeo.Settings.getProperty('serviceUrlFormatter')(this.dataUrl),
            dataType: 'json',
            contentType: 'application/json',
            data: JSON.stringify(flightDetailsDataRequest),
            processData: true,
            silent,
        });
        this.options = Odigeo.parseOptions(this.widget.options);
        this.set('isDeparture', leg === 0, {silent});
        this.set('segmentNumber', leg, {silent});
    },
    hasBlockedStopOverCountriesForUpsell(selectedSegments) {
        const blockedStopOversForIP = Odigeo.JCMS.blockedStopOversForIP;
        let result = false;
        selectedSegments[0].sections.forEach((section) => {
            if (blockedStopOversForIP.indexOf(section.departureLocation.countryCode) !== -1) {
                result = true;
            }
        });
        return result;
    },
    isAllowedFareItineraryType(flightDetailsDTO) {
        if (Odigeo.SessionScope.isMeta) {
            return !flightDetailsDTO.isVIN;
        } else {
            return (flightDetailsDTO.fareItineraryType === 'STANDARD' ||
                flightDetailsDTO.fareItineraryType === 'CROSS_FARING');
        }
    },
    checkShowIpTouchpoint() {
        let showTouchpoint = false;
        const flightDetailsDTO = this.get('flightDetailsDTO');
        const touchpointABActive = Odigeo.SessionScope.isMeta ? Odigeo.AB.isTouchpointForMetas : Odigeo.AB.isUpsellTouchpoint;
        if (Odigeo.SessionScope.flow === MOBILEFLOW && touchpointABActive && flightDetailsDTO) {
            const allowedFareItineraryType = this.isAllowedFareItineraryType(flightDetailsDTO);
            const touchpointPreviouslyHit = Odigeo.Utils.parseJson(Odigeo.Session.get('isIpTchpntHit'));
            const hasAccommodationSelection = this.get('bookingData') && this.get('bookingData').hasAccommodationSelection;
            const hasBlockedStopOverCountriesForUpsell = this.hasBlockedStopOverCountriesForUpsell(flightDetailsDTO.segments);

            const touchpointConditionsAccomplished = allowedFareItineraryType &&
                !hasBlockedStopOverCountriesForUpsell &&
                this.checkIntermediatePageRules() &&
                !hasAccommodationSelection;

            if (touchpointPreviouslyHit) {
                const previousAccommodationResults = !window.location.hash.includes('no_results');
                showTouchpoint = previousAccommodationResults && !hasAccommodationSelection;
            } else {
                showTouchpoint = touchpointConditionsAccomplished;
            }
        }

        return showTouchpoint;
    },
    checkIntermediatePageRules() {
        let intPageActivationRulesAccomplished;
        const searchParams = JSON.parse(Odigeo.Session.get('searchParameters'));
        Odigeo.requireWidget('intermediatepage-dpupsellactivationrules-manager', 'dp_upsell_activation_rules_manager',
            function(dpUpsellActivationRulesManager) {
                intPageActivationRulesAccomplished = dpUpsellActivationRulesManager.execute('areActivationRulesAccomplished', {
                    searchParams: searchParams,
                });
            }
        );
        return intPageActivationRulesAccomplished;
    },
    getBookingData() {
        const data = this.get('bookingData');
        return {
            searchID: data.itinerary.fareItinerarySearchId,
            itineraryID: data.itinerary.mainItineraryId,
            segmentPositions: data.segmentPositions,
            selectedSegments: this.getSelectedSegments(data.segmentIndex, data.itinerary),
            selectedItinerary: data.itinerary,
            primeOptionSelected: data.primeOptionSelected,
            isPriceWithoutDiscountSelected: data.isPriceWithoutDiscountSelected,
            returningUserDeviceId: data.returningUserDeviceId,
        };
    },
    getSelectedSegments(segmentIndex, itinerary) {
        return Odigeo._.map(segmentIndex, function(value, index) {
            return itinerary.itineraryGroupsList[index].segItems[value];
        });
    },
    getNumPassengers() {
        return this.getPriceCollectionData().numPassengers;
    },
    getFooterData() {
        return this.get('bookingData');
    },
    storeBoardingOptions(data) {
        this.set('boardingOptions', data);
    },
    renderFlexAlert: function() {
        const insuranceCatalogue = insuranceCatalogueCollection.getInstance();
        insuranceCatalogue.getLoadedPromise().then((loaded) => {
            if (loaded && insuranceCatalogue.isCancellationFreeCandidate()) {
                this.renderPromotionalMessage = Odigeo.Utils.parseJson(Odigeo.Session.get('isFlexibilityDisruptionWaitingActive'));
                this.widget.renderFlexAlert(this.renderPromotionalMessage);
            }
        });
    },
    shouldUseMetaEndpoint() {
        return Odigeo.AB.isPreCreateShoppingCartMeta && Odigeo.History.getPageNameFromFragment() === FLIGHT_SUMMARY_PAGE;
    },
}));
